import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class splashScreen extends Vue {
  @Prop({ default: true })
  loader: boolean;
}
